//---------------------
//내집스캔 페이(도비)
//---------------------
const dobyRouter = [
  {
    path: "/doby",
    name: "doby-base",
    component: () => import("../views/doby/BaseView.vue"),
  },
  {
    path: "/doby/landing",
    name: "doby-landing",
    component: () => import("../views/doby/LandingView.vue"),
  },
  {
    path: "/doby/landing-ad",
    name: "doby-landing-ad",
    component: () => import("../views/doby/LandingAdView.vue"),
  },
  // 후기 전용 페이지 (NZSC-3255). 랜딩 후기 섹션 '더 보기'에서 진입.
  {
    path: "/doby/reviews",
    name: "doby-reviews",
    component: () => import("../views/doby/ReviewListView.vue"),
  },
  {
    path: "/doby/login",
    name: "doby-login",
    component: () => import("../views/doby/LoginView.vue"),
  },

  // 목록.
  {
    path: "/doby/list",
    name: "doby-list",
    component: () => import("../views/doby/ListView.vue"),
  },

  // 등록.
  {
    path: "/doby/register",
    name: "doby-register-entry",
    component: () => import("../views/doby/register/RegisterEntryView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/register/owner",
    name: "doby-register-owner",
    component: () => import("../views/doby/register/RegisterOwnerView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/register/date",
    name: "doby-register-date",
    component: () => import("../views/doby/register/RegisterDateView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/register/contract",
    name: "doby-register-contract",
    component: () => import("../views/doby/register/RegisterContractView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/register/reject-contract",
    name: "doby-register-reject-contract",
    component: () => import("../views/doby/register/RegisterRejectContractView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/register/payment",
    name: "doby-register-payment",
    component: () => import("../views/doby/register/RegisterPaymentView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/register/review",
    name: "doby-register-review",
    component: () => import("../views/doby/register/RegisterReviewView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // 등록 V2. (250730: 퍼널 순서 변경 (결제 -> 소유주 등록 -> 계약서 등록))
  {
    path: "/doby/v2/register/payment",
    name: "doby-v2-register-payment",
    component: () => import("../views/doby/register/v2/RegisterPaymentViewV2.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  // V3 결제화면 리디자인 (NZSC-3255). V2는 라이브 유지, 컷오버는 배포 단계에서 수동.
  {
    path: "/doby/v3/register/payment",
    name: "doby-v3-register-payment",
    component: () => import("../views/doby/register/v2/RegisterPaymentViewV3.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/v2/register/payment-success",
    name: "doby-v2-register-payment-success",
    component: () => import("../views/doby/register/v2/RegisterPaymentSuccessV2.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/v2/register/owner",
    name: "doby-v2-register-owner",
    component: () => import("../views/doby/register/v2/RegisterOwnerViewV2.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/v2/register/contract",
    name: "doby-v2-register-contract",
    component: () => import("../views/doby/register/v2/RegisterContractViewV2.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/v2/register/billing",
    name: "doby-v2-register-billing",
    component: () => import("../views/doby/register/v2/RegisterBillingKeyViewV2.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },

  // 등록 이후.
  {
    path: "/doby/dashboard",
    name: "doby-dashboard",
    component: () => import("../views/doby/DashboardView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/manage",
    name: "doby-manage",
    component: () => import("../views/doby/ManageView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/reorder",
    name: "doby-reorder",
    component: () => import("../views/doby/ReorderView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/cancel/termination",
    name: "doby-cancel-termination",
    component: () => import("../views/doby/cancel/CancelTerminationView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/doby/cancel/refund",
    name: "doby-cancel-refund",
    component: () => import("../views/doby/cancel/CancelRefundView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
];

export default dobyRouter;
